/**
 * packages/pageweb/src/common/function.tsx 의 대체 함수.
 * 원본 함수는 환경변수에 dependency 를 갖고있어 공통 코드로 쓸 수 있도록 새로 만듬
 */
export function getKageUrl({
  kageUrlPrefix,
  kageId,
  resolution,
  size,
  version,
}: {
  kageUrlPrefix: string;
  kageId: string;
  resolution?: 'o1' | 'th1' | 'th2' | 'th3' | 'th4';
  size?: string;
  version?: string;
}): string {
  const kageUrlSuffix = (resolution && `&filename=${resolution}`) || '';
  return `${kageUrlPrefix}${kageId}${kageUrlSuffix}${size ? `/${size}` : ''}${
    version ? `&v=${version}` : ''
  }`;
}
